<template>
  <div class="bg">
    <div class="top_search_part">
      <div class="goBackBox" @click="backFirstLevel">
        <img class="goBackIcon" src="@/assets/backIcon.svg" />
        <span class="goBackTitle">{{$t('message.backText')}}</span>
      </div>
      <div class="search_box">
        <div v-if="$store.state.JHSS.personalUserid.includes('admin')" class="search_btn" @click="setLogistics">{{$t('message.batchUpdateLogisticsInfo')}}</div>
        <div v-if="$store.state.JHSS.personalUserid.includes('admin')" class="search_btn" @click="setStatus">{{$t('message.batchSetStatus')}}</div>
        <div v-if="$store.state.JHSS.personalUserid.includes('admin')" class="search_btn" @click="delOrders">{{$t('message.batchDelete')}}</div>
        <div v-if="$store.state.JHSS.personalUserid.includes('admin')" class="search_btn" @click="delOrdersYs">{{$t('message.batchDeleteYs')}}</div>
        <div class="search_btn" @click="exportContainerDetail">{{$t('message.exportText')}}</div>
      </div>
    </div>
    <div class="content">
      <div class="tableBox">
        <el-table id="orderList" :data="orderList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" v-loading="loading" height="100%" @selection-change="selectOrder">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="65"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle11')" prop="ADDTIME" min-width="170"></el-table-column>
          <el-table-column :label="$t('message.signInOrderCustomer') + 'ID'" prop="GUDING3" width="150"></el-table-column>
          <el-table-column :label="$t('message.mainOrderNum')" prop="MBLNO" width="150"></el-table-column>
          <el-table-column :label="$t('message.deputyOrderNum')" prop="HBLNO" width="150"></el-table-column>
          <el-table-column :label="$t('message.numInOrder')" prop="SL" width="80"></el-table-column>
          <el-table-column :label="$t('message.containerOrderVolume')" prop="GUDING4" width="80"></el-table-column>
          <el-table-column :label="$t('message.containerOrderWeight')" prop="ZL" width="90"></el-table-column>
          <el-table-column :label="$t('message.addressInOrder')" min-width="160" class-name="addColumn">
            <template slot-scope="scope">
              <div v-html="scope.row.DELIVERYADD"></div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.estimatedTimeArrival')" prop="JHR" width="170"></el-table-column>
          <el-table-column :label="$t('message.containerOrderRemark')" prop="GUDING5" width="100"></el-table-column>
          <el-table-column :label="$t('message.signatureStateTitle')" width="100">
            <template slot-scope="scope">
              <a class="operation_a_green" @click="checkStatusRemark(scope.row.ID)" v-if="scope.row.STATE === '1'">{{$t('message.signInOrderStatus2')}}</a>
              <a class="operation_a_red" @click="checkStatusRemark(scope.row.ID)" v-if="scope.row.STATE === '2'">{{$t('message.signInOrderStatus1')}}</a>
            </template>
          </el-table-column>
		  <el-table-column :label="$t('message.deliverySituationY')" width="100" v-if="$store.state.JHSS.personalUserid.includes('admin')">
		    <template slot-scope="scope">
			  <div style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"	v-html="scope.row.SHQKY"></div>
		    </template>
		  </el-table-column>
		  <el-table-column :label="$t('message.deliverySituation')" width="100">
		    <template slot-scope="scope">
			  <div style="text-decoration:none;cursor:pointer;width:100%;height: 100%; display: block;"	v-html="scope.row.SHQK"></div>
		    </template>
		  </el-table-column>
          <el-table-column :label="$t('message.deliveryOrderTitle')" width="90" v-if="specialIdentity === 'FC' || specialIdentity === 'PDF'|| specialIdentity === 'administrator' || $store.state.JHSS.personalUserid === '82aaf409-3513-43ac-bb50-f44bec67515d' || $store.state.JHSS.personalUserid === 'fa611024-fadf-48b2-8a7d-63431b914263'|| $store.state.JHSS.personalUserid === '8884c74f-b89c-41ed-9d09-5dc6704f8554' || $store.state.JHSS.personalUserid === 'dc569fe5-2ddf-49d6-a616-48b816a41ecf'">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <a class="operation_a_blue" target="_blank" :href="url + '/pdf/WlAmazon?ID=' + scope.row.ID">{{$t('message.signatureHasOrder')}}</a>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" min-width="140">
            <template slot-scope="scope">
              <a class="operation_a_blue" @click="checkLogistics(scope.row.ID)">{{$t('message.checkLogisticsText')}}</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
    <!-- 批量设置物流信息 -->
    <el-dialog :title="$t('message.batchUpdateLogisticsInfo')" :visible.sync="showBatchLogistitics"  width="30%" destroy-on-close :close-on-click-modal="false">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <div class="dialog_item_title">{{$t('message.goodsDescription')}}：</div>
            <el-input v-model="goodsDescription" :placeholder="$t('message.placeholder')"></el-input>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <div class="dialog_item_title">{{$t('message.deliverySituation')}}：</div>
            <el-select v-model="deliverySituation" :placeholder="$t('message.exportDatePlaceholder')" style="width: 100%;">
              <el-option :label="$t('message.deliverySituation1')" value="已提货"></el-option>
              <el-option :label="$t('message.deliverySituation2')" value="配送中"></el-option>
              <el-option :label="$t('message.deliverySituation3')" value="已派送"></el-option>
              <el-option :label="$t('message.deliverySituation4')" value="提回仓库"></el-option>
              <el-option :label="$t('message.deliverySituation5')" value="拒收"></el-option>
              <el-option :label="$t('message.deliverySituation6')" value="再次派送"></el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <div class="dialog_item_title">{{$t('message.logisticsDate')}}：</div>
            <el-date-picker
              :picker-options="deliverySituation=='已派送'?pickerOptions2:pickerOptions1"
              v-model="logisticsDate"
              type="datetime"
              :placeholder="$t('message.exportDatePlaceholder')"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm:ss"
              style="width: 100%;"
            ></el-date-picker>          
	    </div>
        </div>
        <div class="dialog_row">
           <!-- v-if="deliverySituation === '提回仓库' || deliverySituation === '拒收'" -->
          <div class="dialog_item">
            <div class="dialog_item_title">{{$t('message.orderStatusRemark')}}：</div>
            <el-input v-model="orderLogisticsRemark" type="textarea" :rows="3" :placeholder="$t('message.placeholder')" style="width: 100%;"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showBatchLogistitics = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="confirmSetLogistics">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 批量设置状态 -->
    <el-dialog :title="$t('message.batchSetStatus')" :visible.sync="showBatchStatus"  width="30%" destroy-on-close :close-on-click-modal="false">
      <div class="dialog_box">
        <div class="dialog_row">
          <div class="dialog_item">
            <div class="dialog_item_title">{{$t('message.setOrderStatus')}}：</div>
            <el-select v-model="setOrderStatus" style="width: 100%;">
              <el-option :label="$t('message.signInOrderStatus2')" value="1"></el-option>
              <el-option :label="$t('message.signInOrderStatus1')" value="2"></el-option>
            </el-select>
          </div>
        </div>
        <div class="dialog_row">
          <div class="dialog_item">
            <div class="dialog_item_title">{{$t('message.orderStatusRemark')}}：</div>
            <el-input v-model="orderStatusRemark" type="textarea" :rows="3" :placeholder="$t('message.placeholder')" style="width: 100%;"></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showBatchStatus = false">{{$t('message.cancleText')}}</el-button>
          <el-button type="primary" @click="confirmSetStatus">{{$t('message.confirmText')}}</el-button>
        </span>
      </div>
    </el-dialog>
    <!-- 查看物流信息 -->
    <el-dialog :title="$t('message.checkLogisticsText')" :visible.sync="checkLogisticsDialog"  width="50%" destroy-on-close :close-on-click-modal="false">
      <div class="dialog_box">
        <el-table id="logisticsList" :data="logisticsList" style="width: 100%" size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer">
          <el-table-column :label="$t('message.goodsDescription')" prop="HWQK" min-width="120"></el-table-column>
          <el-table-column :label="$t('message.deliverySituation')" prop="deliverySituation" min-width="170"></el-table-column>
          <el-table-column :label="$t('message.logisticsDate')" prop="TAKETIME" min-width="180"></el-table-column>
          <el-table-column :label="$t('message.orderStatusRemark')" prop="GUDING1" min-width="140"></el-table-column>
          <el-table-column :label="$t('message.customTableTitle5')" width="120" v-if="$store.state.JHSS.personalUserid.includes('administrator') || $store.state.JHSS.personalUserid === '231b7d38-893d-4f77-9821-bf668b81b86badmin'|| $store.state.JHSS.personalUserid === '11d7a4b1-ee7f-430c-a936-a5d355534e6dadmin'|| $store.state.JHSS.personalUserid === '247ddfb7-3707-4c55-bfb5-b689038cca82admin' ">
            <template slot-scope="scope">
              <el-button class="operation_btn" type="text" size="small" @click.native.prevent="delOrderLogistics(scope.row.ID, scope.row.PID)">{{$t('message.delOrderText')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const moment = require('moment')
  import { getAmazonOrder, batchSetLogistics, batchSetStatus, checkOrderStatus, checkOrderLogistics, batchDelOrders,batchDelOrdersYs, delOrderLogistics, exportContainerDetail, HTTPS } from '@/api/getData.js'
  export default {
    name: 'orderList',
    props: {
      containerId: '',
      orderNo: {
        type: String,
        default: ''
      },
      orderTime: {
        type: Object,
        default: null
      },
      orderStatus: {
        type: String,
        default: ''
      },
      orderAddress: {
        type: String,
        default: ''
      },
      searchCustomer: {
        type: String,
        default: ''
      },
      orderRemark: {
        type: String,
        default: ''
      },
      logisticsStatus: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        loading: false,
        orderList: [],
        orderSel: [], // 选中的亚马逊订单
        page_no: 1,
        page_size: 50,
        totalSize: 0,
        pageSizes: [50, 100, 200, 300, 500, 1000],
        showBatchLogistitics: false,
        showBatchStatus: false,
        goodsDescription: '', // 货物状况
        deliverySituation: '', // 物流状态
        logisticsDate: '', // 物流更新日期
        orderLogisticsRemark: '', // 物流轨迹备注说明
        setOrderStatus: '1',
        orderStatusRemark: '', // 货物状况备注
        checkLogisticsDialog: false,
        logisticsList: [],
        exportJson: {},

      pickerOptions: {},
      pickerOptions1:{
        disabledDate(time) {
          return (
            // 不能选择大于今天的日期
            time.getTime() > Date.now()
          )
        },
        selectableRange: `00:00:00 - 23:59:59`, //这里是限制可选时间到时分秒
        //selectableRange: `00:00:00 - ${moment().format('HH:mm:SS')}`, //这里是限制可选时间到时分秒
      },
      pickerOptions2: {
        disabledDate(time) {
          return false
        },
        selectableRange: `00:00:00 - 23:59:59`, //这里是限制可选时间到时分秒
      },
    }
  },
  mounted() {
    this.getAmazonOrder()
  },
  created() {
    this.isAdmin = this.$store.state.JHSS.personalUserid.includes('admin')
    this.specialIdentity =
      this.$store.state.JHSS.personalUserid !== 'administrator'
        ? this.$store.state.JHSS.personalSpecial
        : 'administrator'
  },
  //使用watch时间监听时间控件的值
  watch: {
    logisticsDate(selectTime) {
      const date = moment(selectTime).format('YYYY-MM-DD')
      const today = moment().format('YYYY-MM-DD')
      if (date === today) {
        //如果选择是日期是当天
        // 先把时间控件的值赋值当前时间
        // this.logisticsDate = moment().format('YYYY-MM-DD HH:mm:SS')
        //然后限制时间小于此时此刻的时分秒不可选
        this.pickerOptions.selectableRange = `00:00:00 - ${moment().format(
          'HH:mm:ss'
        )}`
      } else {
        //如果选择是日期是明天或者更远的时间
        // 先把时间控件的值赋值为一天的的开始
        // this.logisticsDate = moment().format('YYYY-MM-DD 00:00:00')
        // 然后把时分秒的限制放开
        this.pickerOptions.selectableRange = '00:00:00 - 23:59:59'
      }
    },
  },
    methods: {
      // 查询订单
      async getAmazonOrder (param) {
        this.loading = true
        param = param || {}
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        param.JZXID = this.containerId
        param.USERID = this.$store.state.JHSS.personalUserid
        let res = await getAmazonOrder(param)
        this.loading = false
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          this.exportJson = param
          this.totalSize = res.data.num
          let index = (this.page_no - 1) * this.page_size
          this.orderList = res.data.dt.map(item => {
            item.index = ++index
            item.ADDTIME = item.ADDTIME.replace(/T/g, ' ')
            // item.DELIVERYADD = !item.DELIVERYADD ? '' : item.DELIVERYADD.replace(/<br\/>/g, '\n')
			//<el-option :label="$t('message.deliverySituation1')" value="已提货"></el-option>
			//<el-option :label="$t('message.deliverySituation2')" value="配送中"></el-option>
			//<el-option :label="$t('message.deliverySituation3')" value="已派送"></el-option>
			//<el-option :label="$t('message.deliverySituation4')" value="提回仓库"></el-option>
			//<el-option :label="$t('message.deliverySituation5')" value="拒收"></el-option>
			//<el-option :label="$t('message.deliverySituation6')" value="再次派送"></el-option>
			if(this.$store.state.lang==='ja'){
				//審査待ち、審査済、確認済、出荷済
				//待审核、已审核、已确认、已发货
				if(item.SHQK!=null && item.SHQK.indexOf('已提货')>=0){item.SHQK=item.SHQK.replace('已提货','貨物集荷')}				
				if(item.SHQK!=null && item.SHQK.indexOf('配送中')>=0){item.SHQK=item.SHQK.replace('配送中','配達中')}
				if(item.SHQK!=null && item.SHQK.indexOf('已派送')>=0){item.SHQK=item.SHQK.replace('已派送','配達完了')}
				if(item.SHQK!=null && item.SHQK.indexOf('提回仓库')>=0){item.SHQK=item.SHQK.replace('提回仓库','持ち戻り')}
				if(item.SHQK!=null && item.SHQK.indexOf('拒收')>=0){item.SHQK=item.SHQK.replace('拒收','受取拒否')}
				if(item.SHQK!=null && item.SHQK.indexOf('再次派送')>=0){item.SHQK=item.SHQK.replace('再次派送','再配達')}
				
				
				if(item.SHQKY!=null && item.SHQKY.indexOf('已提货')>=0){item.SHQKY=item.SHQKY.replace('已提货','貨物集荷')}				
				if(item.SHQKY!=null && item.SHQKY.indexOf('配送中')>=0){item.SHQKY=item.SHQKY.replace('配送中','配達中')}
				if(item.SHQKY!=null && item.SHQKY.indexOf('已派送')>=0){item.SHQKY=item.SHQKY.replace('已派送','配達完了')}
				if(item.SHQKY!=null && item.SHQKY.indexOf('提回仓库')>=0){item.SHQKY=item.SHQKY.replace('提回仓库','持ち戻り')}
				if(item.SHQKY!=null && item.SHQKY.indexOf('拒收')>=0){item.SHQKY=item.SHQKY.replace('拒收','受取拒否')}
				if(item.SHQKY!=null && item.SHQKY.indexOf('再次派送')>=0){item.SHQKY=item.SHQKY.replace('再次派送','再配達')}
				
				// if(item.SHQK==='配送中'){item.SHQK='配達中'}
				// if(item.SHQK==='已派送'){item.SHQK='配達完了'}
				// if(item.SHQK==='提回仓库'){item.SHQK='持ち戻り'}
				// if(item.SHQK==='拒收'){item.SHQK='受取拒否'}
				// if(item.SHQK==='再次派送'){item.SHQK='再配達'}
			}
			
            return item
          })
        }
      },
      // 返回
      backFirstLevel () {
        // this.$parent.$data.showCalendar = true
        this.$router.go(-1)
      },
      // 选择订单
      selectOrder (val) {
        this.orderSel = val
      },
      queryOrder () {
        this.searchFun()
      },
      sizeChange (val) {
        this.page_size = val
        this.searchFun()
      },
      currentChange (val) {
        this.searchFun(val)
      },
      searchFun (val) {
        this.page_no = val || 1
        let param = {}
        if (this.orderNo) param.MHBLNO = this.orderNo
        if (this.orderStatus) param.STATE = this.orderStatus
        if (this.orderTime !== null) {
          param.UADDTIME = this.orderTime[0]
          param.DADDTIME = this.orderTime[1]
        }
        if (this.orderAddress) param.DELIVERYADD = this.orderAddress
        if (this.searchCustomer) param.CUSTOMERID = this.searchCustomer
        if (this.orderRemark) param.GUDING5 = this.orderRemark
        if (this.logisticsStatus) param.SHQK = this.logisticsStatus
        this.getAmazonOrder(param)
      },
      // 设置物流信息
      setLogistics () {
        if (this.orderSel.length === 0) {
          this.$message(this.$t('message.signatureInsertTipsText'))
        } else {
          this.goodsDescription = this.$t('message.signInOrderStatus2')
          this.deliverySituation = this.logisticsDate = this.orderLogisticsRemark = ''
          this.showBatchLogistitics = true
        }
      },
      // 设置状态信息
      setStatus () {
        if (this.orderSel.length === 0) {
          this.$message(this.$t('message.signatureInsertTipsText'))
        } else {
          this.setOrderStatus = '1'
          this.orderStatusRemark = ''
          this.showBatchStatus = true
        }
      },
      // 确认设置物流状态
      async confirmSetLogistics () {
        if (!this.goodsDescription) {
          this.$message(this.$t('message.goodsDescription'))
          return
        }
        if (!this.deliverySituation) {
          this.$message(this.$t('message.deliverySituation'))
          return
        }
        if (!this.logisticsDate) {
          this.$message(this.$t('message.logisticsDate'))
          return
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let list = this.orderSel.map(item => {
          return item.ID
        })
        let param = {
          PIDLST: list.join(','),
          HWQK: this.goodsDescription,
          SHQK: this.deliverySituation,
          TAKETIME: this.logisticsDate,
          GUDING1: this.orderLogisticsRemark,
          ADDUSER: this.$store.state.JHSS.personalUserid
        }
        let res = await batchSetLogistics(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
			this.getAmazonOrder()
			
          this.showBatchLogistitics = false
        }
      },
      // 确认设置状态
      async confirmSetStatus () {
        if (!this.orderStatusRemark) {
          this.$message(this.$t('message.orderStatusRemark'))
          return
        }
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let list = this.orderSel.map(item => {
          return item.ID
        })
        let param = {
          PIDLST: list.join(','),
          STATE: this.setOrderStatus,
          REMARK: this.orderStatusRemark,
          ADDUSER: this.$store.state.JHSS.personalUserid
        }
        let res = await batchSetStatus(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else if (res.data.result !== '1') {
          this.$message.error(res.data.message)
        } else {
          this.showBatchStatus = false
          this.searchFun()
        }
      },
      // 查看状态说明
      async checkStatusRemark (id) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = { PID: id }
        let res = await checkOrderStatus(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else if (res.data.length !== 0) {
          this.$confirm(res.data[0].REMARK, this.$t('message.orderStatusRemark'), {
            center: true,
            showCancelButton: false,
            showConfirmButton: false
          })
        } else {
          return
        }
      },
      // 查看物流信息
      async checkLogistics (id) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = { PID: id }
        let res = await checkOrderLogistics(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          this.logisticsList = res.data.map(item => {
            item.TAKETIME = item.TAKETIME.replace(/T/g, ' ')
            if (item.SHQK === '已提货') {
              item.deliverySituation = this.$t('message.deliverySituation1')
            } else if (item.SHQK === '配送中') {
              item.deliverySituation = this.$t('message.deliverySituation2')
            } else if (item.SHQK === '已派送') {
              item.deliverySituation = this.$t('message.deliverySituation3')
            } else if (item.SHQK === '提回仓库') {
              item.deliverySituation = this.$t('message.deliverySituation4')
            } else if (item.SHQK === '拒收') {
              item.deliverySituation = this.$t('message.deliverySituation5')
            } else if (item.SHQK === '再次派送') {
              item.deliverySituation = this.$t('message.deliverySituation6')
            } else {
              item.deliverySituation = item.SHQK
            }
            return item
          })
          this.checkLogisticsDialog = true
        }
      },
      // 批量删除
      delOrders () {
        if (this.orderSel.length === 0) {
          this.$message(this.$t('message.signatureInsertTipsText'))
        } else {
          this.$confirm(this.$t('message.orderPrompt'), this.$t('message.promptTitle'), {
            type: 'warning',
            showClose: false,
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            center: true,
            confirmButtonText: this.$t('message.confirmText'),
            cancelButtonText: this.$t('message.cancleText'),
            callback: async (action) => {
              if (action === 'confirm') {
                let list = this.orderSel.map(item => {
                  return item.ID
                })
                let param = { PIDLST: list.join(',') }
                let res = await batchDelOrders(param)
                if (res.status !== 200) {
                  this.$message.error('network error：' + res.status)
                } else if (res.data.result !== '1') {
                  this.$message.error(res.data.message)
                } else {
                  this.searchFun()
                }
              }
            }
          })
        }
      },
      // 批量删除预设
      delOrdersYs () {
        if (this.orderSel.length === 0) {
          this.$message(this.$t('message.signatureInsertTipsText'))
        } else {
          this.$confirm(this.$t('message.orderPromptYs'), this.$t('message.promptTitle'), {
            type: 'warning',
            showClose: false,
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            center: true,
            confirmButtonText: this.$t('message.confirmText'),
            cancelButtonText: this.$t('message.cancleText'),
            callback: async (action) => {
              if (action === 'confirm') {
                let list = this.orderSel.map(item => {
                  return item.YID
                })
                let param = { PIDLST: list.join(',') }
                let res = await batchDelOrdersYs(param)
                if (res.status !== 200) {
                  this.$message.error('network error：' + res.status)
                } else if (res.data.result !== '1') {
                  this.$message.error(res.data.message)
                } else {
                  this.searchFun()
                }
              }
            }
          })
        }
      },
      // 删除物流
      delOrderLogistics (id, pid) {
        this.$confirm(this.$t('message.delOrderLogisticsPrompt'), this.$t('message.delOrderText'), {
          type: 'warning',
          showClose: false,
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          center: true,
          confirmButtonText: this.$t('message.confirmText'),
          cancelButtonText: this.$t('message.cancleText'),
          callback: async (action) => {
            if (action === 'confirm') {
              let param = { ID: id }
              let res = await delOrderLogistics(param)
              if (res.status !== 200) {
                this.$message.error('network error：' + res.status)
              } else if (res.data.result !== '1') {
                this.$message.error(res.data.message)
              } else {
                this.checkLogistics(pid)
              }
            }
          }
        })
      },
      // 导出订单
      async exportContainerDetail () {
        let param = this.exportJson
        delete param.PAGE
        delete param.TYPE
        let res = await exportContainerDetail(param)
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
        } else {
          window.open(HTTPS + "/xlsx/" + res.data)
        }
      }
    },
    computed: {
      url () {
        return HTTPS
      }
    }
  }
</script>

<style scoped>
/deep/ .addColumn .cell div{
  /* word-break: keep-all; */
  text-align: left;
}
.tableBox .operation_btn {
  height: initial;
}
</style>
